// `?from=` carries the source context when a user navigates from a property
// (or unit) into a device detail page. It lets the device-delete handler
// route back to the right page after deletion instead of bouncing the user
// to the global Devices list. Format: `kind:id` so we can extend later (e.g.
// `building:<id>`, `gateway:<id>`) without breaking existing links.

export type DeviceNavSource = 'property' | 'unit';

export function deviceDetailPath(deviceId: string, from?: { kind: DeviceNavSource; id: string }): string {
  const base = `/devices/${deviceId}`;
  if (!from) return base;
  return `${base}?from=${from.kind}:${from.id}`;
}

interface ParsedSource {
  kind: DeviceNavSource;
  id: string;
}

export function parseDeviceNavFrom(raw: string | null): ParsedSource | null {
  if (!raw) return null;
  const colon = raw.indexOf(':');
  if (colon <= 0) return null;
  const kind = raw.slice(0, colon);
  const id = raw.slice(colon + 1);
  if (!id) return null;
  if (kind !== 'property' && kind !== 'unit') return null;
  return { kind, id };
}

export function pathForSource(source: ParsedSource): string {
  switch (source.kind) {
    case 'property': return `/properties/${source.id}`;
    case 'unit': return `/units/${source.id}`;
  }
}
